<template>
  <v-container fluid class="szervezetek hirlista-oldal">
    <v-btn
      icon
      large
      color="primary"
      class="back-btn"
      @click="$goBackTo({ name: 'Fooldal' })"
    >
      <i class="fas fa-chevron-left"></i>
    </v-btn>
    <h2>Szervezetek</h2>
    <v-tabs
      show-arrows
      next-icon="fas fa-angle-right"
      prev-icon="fas fa-angle-left"
      v-model="tab"
      class="mt-2"
    >
      <v-tabs-slider color="primary"></v-tabs-slider>

      <v-tab v-for="szervezet in szervezetekSorrendezve" :key="szervezet.Id">
        {{ szervezet.Text }}
      </v-tab>
    </v-tabs>
    <v-tabs-items
      :touchless="true"
      :next-icon="false"
      :prev-icon="false"
      v-model="tab"
    >
      <v-tab-item
        v-for="szervezet in szervezetekSorrendezve"
        :key="szervezet.Id"
      >
        <k-hir-lista :getHirek="GetHirek(szervezet.Id)"></k-hir-lista>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { hirService } from '../services/HirService';
import { AppStoreTypes } from '../store/modules/app';

export default {
  name: 'Szervezetek',
  data() {
    return {
      tab: null,
    };
  },
  mounted() {},
  created() {},
  methods: {
    GetHirek(szervezetId) {
      return utolsoHir => {
        return hirService.GetHirek({
          szerzoId: szervezetId,
          utolsoHirId: utolsoHir?.Id,
        });
      };
    },
  },
  computed: {
    ...mapGetters({
      szervezetek: AppStoreTypes.szervezetek.getAll,
      user: AppStoreTypes.user.get,
    }),
    tabUpdate() {
      return [this.szervezetekSorrendezve.length, this.routeSzervezetId].join(
        '_'
      );
    },
    szervezetekSorrendezve() {
      return AppFunctions.SortSzerzok(this.szervezetek, this.user);
    },
    routeSzervezetId() {
      return this.$route.params.id;
    },
  },
  watch: {
    tabUpdate: {
      handler(v) {
        let routeSzervezetId = this.routeSzervezetId;
        let idx = this.szervezetekSorrendezve.findIndex(
          f => f.Id == routeSzervezetId
        );
        if (idx) {
          this.tab = idx;
        }
      },
      immediate: true,
    },
  },
  components: {},
};
</script>
